import React from 'react';
import { createRoot } from 'react-dom/client';
import { createGlobalStyle } from 'styled-components';
import { eventCollectorPageViewsObjectPage, trackPageViewObject } from 'common/lib/helpers/trackingService';
import { DataProvider, getDataContext } from 'common/lib/helpers/DataContext';
import {
    AD_TYPE_ETS,
    AD_TYPE_KFS,
    AD_TYPE_PTS,
    AD_TYPE_PTS_UNIT,
    AD_TYPE_PTSF,
    AD_TYPE_PTSF_UNIT,
} from 'common/lib/helpers/constants';
import Kfs from './pages/Kfs';
import PtsMaster from './pages/PtsMaster';
import PtsUnit from './pages/PtsUnit';
import Ptsf from './pages/Ptsf';
import PtsfUnit from './pages/PtsfUnit';
import Ets from './pages/Ets';

const container = document.getElementById('ad-content');
const root = createRoot(container);

const GlobalStyle = createGlobalStyle`
.top-bar__spacer {
    height: 50px !important;
}
.lightbox-hidden {
    /* Fix image carousel lightbox switch big picture and thumbnails specificity */
    display: none !important; 
}

.lightbox__thumb-link:focus {
    outline: 1px solid #fff;
    outline-offset: 1px;
}

.lightbox__thumbs {
    overflow-y: unset;
}
`;

if (container) {
    const data = getDataContext('ad-data');
    const { adType, createdBy, broadcastUrl } = data;

    const App = () => {
        switch (adType) {
            case AD_TYPE_KFS:
                return <Kfs data={data} />;
            case AD_TYPE_PTS:
                return <PtsMaster data={data} />;
            case AD_TYPE_PTS_UNIT:
                return <PtsUnit data={data} />;
            case AD_TYPE_ETS:
                return <Ets data={data} />;
            case AD_TYPE_PTSF:
                return <Ptsf data={data} />;
            case AD_TYPE_PTSF_UNIT:
                return <PtsfUnit data={data} />;
            default:
                return null;
        }
    };

    eventCollectorPageViewsObjectPage(createdBy);
    trackPageViewObject();
    root.render(
        <DataProvider value={data}>
            <GlobalStyle />
            <div className="page-container">
                <f-broadcast api={broadcastUrl} url={window.location.hostname + window.location.pathname} />
            </div>
            <App />
        </DataProvider>
    );
}
